<template>
    <div class="detail">
        <el-row class="tac">
        <el-col :span="22" >
          <div style="margin-top:3%;margin-left:10%" >
            <el-card shadow="always" v-if="selectInventoryId!=''">
              <el-radio-group v-model="tableState" @input="findItem">
                <el-radio label="returned">已退样</el-radio>
                <el-radio label="supplied">已补样</el-radio>
                <el-radio label="expired">已过期</el-radio>
                <el-radio label="reportLosses">已报损</el-radio>
                <el-radio label="expiring">临期</el-radio>
              </el-radio-group>
                <el-table
                  :data="items.filter(data => !tableSearch || data.name.toLowerCase().includes(tableSearch.toLowerCase()) ||data.brand.toLowerCase().includes(tableSearch.toLowerCase())||data.properties.toLowerCase().includes(tableSearch.toLowerCase()) )"
                  :max-height="tableHight"
                  style="width: 100%;margin-top:1.5%"
                  :empty-text="loadInfo"
                  v-if="tableState!=''">
                  <el-table-column
                    label="序号"
                    type="index"
                    width=110px>
                  </el-table-column>

                  <el-table-column
                    label="品牌名称"
                    prop="brand"
                    width="auto"
                    min-width="30%">
                  </el-table-column>

                  <el-table-column type="expand">
                    <template slot-scope="props">
                      <el-form label-position="left" inline class="demo-table-expand">
                        <el-form-item label="品牌名称" v-if="props.row.brand">
                          <span>{{ props.row.brand }}</span>
                        </el-form-item>
                        <el-form-item label="商品名称" v-if="props.row.name">
                          <span>{{ props.row.name }}</span>
                        </el-form-item>
                        <el-form-item label="所属店铺" v-if="props.row.shop">
                          <span>{{ props.row.shop }}</span>
                        </el-form-item>
                        <el-form-item label="商品属性" v-if="props.row.properties">
                          <span>{{ props.row.properties }}</span>
                        </el-form-item>
                        <el-form-item label="商品规格" v-if="props.row.specs">
                          <span>{{ props.row.specs }}</span>
                        </el-form-item>
                        <el-form-item label="商品位置" v-if="props.row.location">
                          <span>{{ props.row.location }}</span>
                        </el-form-item>
                        <el-form-item label="直播价" v-if="props.row.lowPrice">
                          <span>{{ props.row.lowPrice }}</span>
                        </el-form-item>
                        <el-form-item label="商品已拥有" v-if="props.row.hasString">
                          <span>{{ props.row.hasString }}</span>
                        </el-form-item>
                        <el-form-item label="商品描述" v-if="props.row.description">
                          <span>{{ props.row.description }}</span>
                        </el-form-item>
                      </el-form>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="商品名称"
                    width="auto"
                    min-width="38%"
                    prop="name">
                  </el-table-column>
                  <el-table-column
                    label="属性"
                    prop="properties"
                    width="auto"
                    min-width="25%">
                  </el-table-column>
                  <el-table-column
                    v-if="this.tableState !== 'returned' && this.tableState !== 'supplied'"
                    label="过期时间"
                    prop="exp"
                    width="auto"
                    min-width="25%">
                  </el-table-column>
                  <el-table-column label="操作"  width="auto" min-width="20%">
                    <template slot="header" slot-scope="scope">
                            <el-input
                            v-model="tableSearch"
                            size="mini"
                            placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                       <el-button size="mini" type="primary" @click="update(scope.$index, scope.row)">修改</el-button>
                    </template>
                  </el-table-column>
                </el-table>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </div>
</template>

<script>
import Common from './Common'
export default {
  name: 'Detail',
  data () {
    return {
      tableHight: window.innerHeight * 0.65,
      tableState: '',
      loadInfo: '暂无数据',
      items: [],
      tableSearch: ''
    }
  },
  mounted () {
  },
  methods: {
    update (index, row) {
      const routeUrl = this.$router.resolve({
        path: '/update',
        query: {
          id: row.id
        }
      })
      window.open(routeUrl.href, '_blank')
      console.log(row.id)
    },
    findItem () {
      this.items = []
      let state = 0
      if (this.tableState === 'returned') state = 1
      if (this.tableState === 'expiring') state = 2
      if (this.tableState === 'supplied') state = 3
      if (this.tableState === 'reportLosses') state = 4
      this.loadInfo = '数据加载中'
      this.$axios.get(Common.baseUrl + 'goods/getByState', {params: {state: state}}
      ).then((res) => {
        let code = res.data.code
        if (code === 200) {
          this.loadInfo = '数据加载完毕，暂无数据'
          this.items = res.data.data
          for (let i in this.items) {
            let hasList = this.items[i].has
            this.items[i].hasString = hasList.join(' · ')
          }
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    }
  }
}
</script>
<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Detail.vue